"use strict";function startUnifiedLive$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.startUnifiedLive$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.live.startUnifiedLive";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.18"},_a)),exports.startUnifiedLive$=startUnifiedLive$,exports.default=startUnifiedLive$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/live/startUnifiedLive.js
// module id = 963
// module chunks = 106